(function () {
  document.querySelectorAll('[data-quantity]').forEach(function (wrapper) {
    var dec = wrapper.querySelector('[data-qty-dec]');
    var inc = wrapper.querySelector('[data-qty-inc]');
    var input = wrapper.querySelector('[data-qty-input]');
    if (!dec || !inc || !input) return;

    function fireChange() {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    dec.addEventListener('click', function () {
      var val = parseInt(input.value);
      var min = parseInt(input.min || '1');
      if (val > min) { input.value = val - 1; fireChange(); }
    });
    inc.addEventListener('click', function () {
      input.value = parseInt(input.value) + 1;
      fireChange();
    });
  });
})();
